import {
  Box,
  Flex,
  Spacer
} from '@chakra-ui/react';
import UsersDrawer from '../controls/UsersDrawer';
import ThemeSwitch from '../controls/ThemeSwitch';
import LanguageSelect from '../controls/LanguageSelect';


const TopBar = () => (
  <Box p={4} position={'fixed'} w="100%">
    <Flex align="center">
      <Spacer />

      <LanguageSelect />

      <ThemeSwitch />

      <UsersDrawer />
    </Flex>
  </Box>
);

export default TopBar;
